import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";

export default function ScreenDonSection({context, campagneData, colors = {}})
{
    const [loading, setLoading] = useState(true)
    const [dons, setDons] = useState([])

    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2})

    const partnerMontant = campagneData?.partnerMontant || 1

    const screenOptions = campagneData?.screenOptions || {}


    const getDisplayName = (campagneExtraData = {}) => {
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons = async () => {
        let url = "/campagne/donors/" + campagneData.id

        const res = await ApiService.get(url)
        let _dons = res.data

        if(screenOptions.minMontant){
            _dons = _dons.filter(i => i.montant >= screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding: "0 5vw"}}>
            <div style={{
                overflow: "visible",
                width: "75%",
                height: "15vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row-reverse",
                gap: "1.5vw",
            }}>
                {dons.map((d, index) => {

                    let className = "ytb-don-card"

                    if(index < 4){
                        className += " ytb-don-fade-in"
                    }else{
                        className += " ytb-don-fade-out"
                    }

                    const montant = formater.format(d.montant / partnerMontant)

                    return (
                        <div key={d.id} className={className}>
                            <div style={{
                                height: "55%",
                                width: "100%",
                                backgroundColor: colors.cardTop || "#dfe2f5",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                <span style={{
                                    color: colors.deepBlue || "#122498",
                                    fontSize: "3.5vh",
                                    textAlign: "center",
                                    fontFamily: "YTB-Cerapro-Bold",
                                }}>
                                    {montant} {context.getDonorName(montant)}
                                </span>
                            </div>
                            <div style={{
                                height: "45%",
                                width: "100%",
                                backgroundColor: colors.cardBottom || "#FFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                <span style={{
                                    color: colors.deepBlue || "#122498",
                                    fontSize: "3vh",
                                    textAlign: "center",
                                    fontFamily: "YTB-Cerapro-Thin",
                                    textTransform: "uppercase",
                                    padding: "0 1vw",
                                }}>
                                    {getDisplayName(d.campagneExtraData)}
                                </span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
